import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabB as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabB = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const lowIncomeFirstGenCollegeField = () => {
    const propertyName = pn<AprResponseModel>("lowIncomeFirstGenCollege");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.lowIncomeFirstGenCollege}{" "}
        {formatPercentTotal(props.data?.lowIncomeFirstGenCollege, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const lowIncomeField = () => {
    const propertyName = pn<AprResponseModel>("lowIncome");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.lowIncome} {formatPercentTotal(props.data?.lowIncome, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const firstGenCollegeField = () => {
    const propertyName = pn<AprResponseModel>("firstGenCollege");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.firstGenCollege} {formatPercentTotal(props.data?.firstGenCollege, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const otherField = () => {
    const propertyName = pn<AprResponseModel>("other");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.other} {formatPercentTotal(props.data?.other, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Participant Distribution by Eligibility</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {lowIncomeFirstGenCollegeField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {lowIncomeField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {firstGenCollegeField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {otherField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={9}>
            <PieChart
              id="pie-tab-b"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
              size={{ width: 1200, height: 700 }} // Increase chart size
              legend={{
                // orientation: "vertical", // Horizontal legend
                // orientation: "horizontal", // Horizontal legend
                // verticalAlignment: "bottom", // Place at bottom
                // horizontalAlignment: "right", // Center it
                // margin: { top: 20 }, // Add margin above the legend
                orientation: "vertical", // Vertical legend
                verticalAlignment: "top", // Center legend vertically
                horizontalAlignment: "right", // Align legend to the right of the chart
                margin: { left: 20 }, // Add margin between the chart and legend
              }}
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
